@switch (columnName) {
  @case ('dateTime') {
    <span class="highlighted-text">
      {{ element.date | date }}
    </span>
    <span class="text-secondary">
      {{ element.date | date: timeFormat }}
    </span>
  }
  @case ('date') {
    <span class="highlighted-text">
      {{ element.date | date }}
    </span>
    <span class="text-secondary">
      {{ element.date | date: timeFormat }}
    </span>
  }
  @case ('action') {
    {{ element.action | translate }}
  }
  @case ('actionDoneBy') {
    {{ element.createdBy }}
  }
  @case ('logChanges') {
    @if (!!fieldChangesWithTranslations && fieldChangesWithTranslations.length > 0) {
      @for (change of fieldChangesWithTranslations; track change) {
        <div class="field-change">
          <span class="highlighted-text">
            {{ change.fieldName | translate }}
            {{ change.translationKey | translate }}
          </span>
          <span class="text-secondary">
            <app-text-overflow-label [text]="change.value"></app-text-overflow-label>
          </span>
        </div>
      }
    } @else {
      {{ logActionLabelDescription[element.action] | translate }}
    }
    @if (element.comment) {
      <div class="field-change">
        <span class="highlighted-text">{{ 'adminLogComment' | translate }}</span>
        <span class="text-secondary">
          <app-text-overflow-label [text]="element.comment"></app-text-overflow-label>
        </span>
      </div>
    }
  }
}
